import React from "react";
import ReactDOM from "react-dom/client";
import App from "./main/App";

// Styles Default Files
import TranslateProvider from "./contexts/TranslateContext";
import "./style/colors.scss";
import "./style/global.scss";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <TranslateProvider>
      <App />
    </TranslateProvider>
  </React.StrictMode>
);
